import anime from 'animejs'
import Timer from '@/core/util/Timer'
import { MyUserType } from '@/Types'
import { ViewSize } from '@/Const'
import DocumentView from '@/core/view/DocumentView'
import HorizontalScrollSyncControler from '@/core/controller/HorizontalScrollSyncControler'
import AreaCheckController from '@/core/controller/AreaCheckController'
import InviewController from '@/core/controller/InviewController'
import GalleryCarouselController from '@/controller/GalleryCarouselController'
import MainCarouselController from '@/controller/MainCarouselController'
import JSScrollController from '@/core/controller/JSScrollController'
import MovableView from '@/core/view/MovableView'
import VerticalPositionViewController from '@/core/controller/VerticalPositionViewController'
import AnchorLinks from '@/view/AnchorLinks'
import HeaderView from '@/view/HeaderView'
import SPHeaderView from '@/view/SPHeaderView'

class MyDocument extends DocumentView {
  //ヘッダー
  private headerView!: HeaderView

  //SP用ヘッダー
  private spHeaderView!: SPHeaderView

  /**
   * コンストラクタ
   *
   */
  constructor() {
    super()
  }

  /**
   * ドキュメントが準備が出来たときに呼び出されます
   */
  public docReady(): void {
    super.docReady()

    // 横スクロール時に連携移動させる要素処理
    const horizontalScrollSyncControler = new HorizontalScrollSyncControler()
    const commonHeader: HTMLElement = document.getElementsByClassName(
      'common-header',
    )![0] as HTMLElement
    if (commonHeader) horizontalScrollSyncControler.add(commonHeader)
    const pageLinks: HTMLElement = document.getElementsByClassName(
      'page-links',
    )![0] as HTMLElement
    if (pageLinks) horizontalScrollSyncControler.add(pageLinks)
    horizontalScrollSyncControler.startListen()

    // ページリンク
    if (pageLinks) {
      new AnchorLinks(pageLinks)
    }

    // リンク処理
    const aTagElms = document.querySelectorAll('a')
    ;[].slice.call(aTagElms).forEach((item: HTMLElement, index) => {
      item.addEventListener('click', (evt: MouseEvent) => {
        const href = (evt.currentTarget! as HTMLElement).getAttribute('href')
        if (href && href.substr(0, 1) == '#') {
          // アンカーリンク処理
          evt.preventDefault()
          this.anchorScroll(href)
        } else if (href && href.substr(0, 1) == '/') {
          // サイト内リンク処理
          evt.preventDefault()
          this.pageMove(href)
        }
      })
    })

    // 画面高さをCSSで利用
    const setFillHeight = () => {
      const vh = window.innerHeight
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
    // 画面のサイズ変動があった時に高さを再計算する
    window.addEventListener('resize', setFillHeight)
    // 初期化
    setFillHeight()
  }

  /**
   * すべての読み込みが完了した際に呼び出されます。
   */
  public docLoadAll(): void {
    super.docLoadAll()

    // 表示位置の表示（PC右上のサブリンク）
    const jsAnker = document.getElementsByClassName('js-anker')
    const list: Array<HTMLElement> = [].slice.call(jsAnker)
    if (list.length) {
      const areaCheckController = new AreaCheckController(list)
      areaCheckController.on('changeIndex', (val) => {
        // 対応するラベルを探す
        const jsAnkerLabelCurrent = document.getElementsByClassName(
          'js-anker-label--' + val,
        )
        if (jsAnkerLabelCurrent.length) {
          const jsAnkerLabel = document.getElementsByClassName('js-anker-label')
          ;[].slice.call(jsAnkerLabel).forEach((item: HTMLElement, index) => {
            item.classList.remove('is-active')
          })
          jsAnkerLabelCurrent[0].classList.add('is-active')
        } else if (val == 0) {
          const jsAnkerLabel = document.getElementsByClassName('js-anker-label')
          ;[].slice.call(jsAnkerLabel).forEach((item: HTMLElement, index) => {
            item.classList.remove('is-active')
          })
        }
      })
      areaCheckController.run()
    }

    // ずれて動く要素の処理
    const tmpElms = document.querySelectorAll('.js-movable-view')
    ;[].slice.call(tmpElms).forEach((elem: HTMLElement) => {
      const movableView = new MovableView(elem)
      // movableView.psYScale = 0
      const verticalPositionViewController = new VerticalPositionViewController(
        movableView,
      )
      verticalPositionViewController.startWatch()
    })

    //
    // tab UI for business page.
    //

    // find business-types-wrap element
    const businessTypesWrap = document.getElementsByClassName(
      'business-types-wrap',
    )

    if (businessTypesWrap.length) {
      //

      ;[].slice
        .call(document.getElementsByClassName('js-tab-label'))
        .forEach((element: HTMLElement) => {
          element!.addEventListener('click', (evt: MouseEvent) => {
            evt.preventDefault()
            // 対応するタブボタンを探す
            const tabButtonName = (evt.currentTarget as HTMLElement)!.getAttribute(
              'data-tab-button',
            )
            if (tabButtonName) {
              const event = new Event('click')
              document
                .getElementsByClassName(tabButtonName)![0]
                .dispatchEvent(event)
            }
          })
        })

      // タブ内要素のInView
      let inviewController: InviewController
      let inViewBusiness: HTMLCollection
      const listenInview = (elem: HTMLElement) => {
        // 前回のリストをリセット
        if (inViewBusiness) {
          Array.prototype.slice.call(inViewBusiness).forEach((elem) => {
            elem.classList.remove('isInview')
          })
        }
        inViewBusiness = elem.getElementsByClassName('inView-business')

        //
        // inView 75%
        //
        if (inviewController) inviewController.dispose()
        inviewController = new InviewController()
        inviewController.scale = 0.75
        inviewController.on('onEnter', (elem: any) => {
          elem = elem as HTMLElement
          elem!.classList.add('isInview')
        })
        Array.prototype.slice.call(inViewBusiness).forEach((elem) => {
          inviewController.add(elem)
        })
        inviewController.init()
      }

      // find business-type element
      const businessType = document.getElementsByClassName('business-type')

      // make tab change funciton
      const selectType = (elem: HTMLElement) => {
        ;[].slice.call(businessType).forEach((element: HTMLElement) => {
          // 全てからClassを取り除く
          if (element.classList.contains('is-active')) {
            element.classList.remove('is-active')
          }
          // 新たなタブにClassを設定
          elem.classList.add('is-active')

          listenInview(elem)

          // PC用 サブメニュー表示
          const tabIndex = elem.getAttribute('data-tab-index')
          const jsTabLabelCurrent = document.getElementsByClassName(
            'js-tab-label-' + tabIndex,
          )
          if (jsTabLabelCurrent.length) {
            const jsTabLabel = document.getElementsByClassName('js-tab-label')
            ;[].slice.call(jsTabLabel).forEach((item: HTMLElement, index) => {
              item.classList.remove('is-active')
            })
            jsTabLabelCurrent[0].classList.add('is-active')
          }
        })
      }

      // find button(a) element and listen
      const tabButton = businessTypesWrap[0].querySelectorAll('a')
      ;[].slice.call(tabButton).forEach((element: HTMLElement) => {
        element!.addEventListener('click', (evt: MouseEvent) => {
          evt.preventDefault()
          const elem = evt.target as HTMLElement
          const parent = elem!.parentElement!.parentElement
          if (parent) {
            selectType(parent)
          }
        })
      })
      if (tabButton.length)
        listenInview(tabButton[0]!.parentElement!.parentElement as HTMLElement)
    }

    //
    // hamburger menu (only sp)
    //
    this.spHeaderView = new SPHeaderView()

    //
    // home main carousel
    //
    const mainCarousel = document.getElementsByClassName('main-carousel')
    if (mainCarousel.length) {
      new MainCarouselController(mainCarousel[0] as HTMLElement)
    }

    // start
    this.start()
  }

  /**
   * 開始
   */
  public async start(): Promise<void> {
    await Timer.wait(1000)

    this.watchInView()

    // ヘッダーのmini処理
    this.headerView = new HeaderView()

    //
    // gallery carousel
    //
    const carouselWrap = document.getElementsByClassName('gallery-carousel')

    const inviewController3 = new InviewController()
    inviewController3.scale = 0.85
    inviewController3.on('onEnter', (elem: any) => {
      elem = elem as HTMLElement
      const galleryCarouselController = new GalleryCarouselController(elem)
      galleryCarouselController.init()
    })
    if (carouselWrap.length) {
      inviewController3.add(carouselWrap[0] as HTMLElement)
      inviewController3.init()
    }
  }

  /**
   * InView処理
   */
  watchInView() {
    //
    // inView 75%
    //
    const inviewController = new InviewController()
    inviewController.scale = 0.75
    inviewController.on('onEnter', (elem: any) => {
      elem = elem as HTMLElement
      elem!.classList.add('isInview')
    })
    let list: HTMLCollection = document.getElementsByClassName('inView')
    Array.prototype.slice.call(list).forEach((elem) => {
      inviewController.add(elem)
    })
    inviewController.init()

    //
    // inView 85%
    //
    const inviewController2 = new InviewController()
    inviewController2.scale = 0.85
    inviewController2.on('onEnter', (elem: any) => {
      elem = elem as HTMLElement
      elem!.classList.add('isInview')
    })
    list = document.getElementsByClassName('inView-s')
    Array.prototype.slice.call(list).forEach((elem) => {
      inviewController2.add(elem)
    })
    inviewController2.init()
  }

  /**
   * アンカーリンク
   */
  private anchorScroll(href: string): void {
    const targetElem = document.getElementById(href.substr(1))
    if (targetElem) {
      const jsScrollController = new JSScrollController()
      jsScrollController.run(targetElem, true)
    }
  }

  /**
   * サイト内ページ移動
   */
  private async pageMove(href: string): Promise<void> {
    const bodys = document.getElementsByTagName('body')
    const body = bodys![0]
    if (body) {
      // SP表示でメニューが表示中の場合は閉じる
      if (this.spHeaderView.isSpView() && this.spHeaderView.isShow) {
        this.spHeaderView.toggle()
        await Timer.wait(200)
      }
      this.headerView.dispose()
      body.classList.add('will-leave')
      await Timer.wait(1)
      body.classList.add('leave')
      await Timer.wait(600)
    }

    location.href = href
  }
}
new MyDocument()
